export default {
  path: '/fleet/vehicle-reservation/overview',
  name: 'VehicleReservationOverview',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/VehicleReservationOverview.vue')
}
